// @ts-nocheck
import {Column} from 'react-table'
import {Model} from '@/_metronic/helpers'
import {
  CustomHeader,
  BooleanCell,
  TextCell,
  CountryCell,
  MoneyCell,
  ActionsCell
} from '@/components/table/columns'
import {StatusCell, BalanceCell} from './SupplierCells'

const Columns: ReadonlyArray<Column<Model>> = [{
  Header: (props) => <CustomHeader tableProps={props} title='Name' className='min-w-70px sortable' />,
  id: 'name',
  Cell: ({...props}) => <TextCell content={props.data[props.row.index].name} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Slug' className='min-w-70px sortable' />,
  id: 'slug',
  Cell: ({...props}) => <TextCell content={props.data[props.row.index].slug} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Country' className='text-center min-w-70px sortable' />,
  id: 'region',
  className: 'text-center',
  Cell: ({...props}) => <CountryCell countryCode={props.data[props.row.index].country} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Currency' className='min-w-70px sortable' />,
  id: 'currency',
  Cell: ({...props}) => <TextCell content={props.data[props.row.index].currency} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='API' className='min-w-70px text-center pe-0 sortable' />,
  id: 'api',
  className: 'text-end pe-0',
  Cell: ({...props}) => <BooleanCell value={props.data[props.row.index].apiAvailable} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='VAT' className='min-w-70px text-center pe-0 sortable' />,
  id: 'vat',
  className: 'text-end pe-0',
  Cell: ({...props}) => <BooleanCell value={props.data[props.row.index].vat > 0} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='BALANCE' className='min-w-70px text-end pe-0 sortable' />,
  id: 'balance',
  className: 'text-end pe-0',
  Cell: ({...props}) => <BalanceCell balance={props.data[props.row.index].balance} currency={props.data[props.row.index].currency} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='STATUS' className='min-w-70px text-end pe-0 sortable' />,
  id: 'status',
  className: 'text-end pe-0',
  Cell: ({...props}) => <StatusCell status={props.data[props.row.index].status} />,
}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
  ),
  id: 'actions',
  Cell: ({...props}) => (
    <ActionsCell
      itemForUpdate={props.data[props.row.index]}
      actions={[{
        icon: 'pencil',
        label: 'Edit',
        openModal: 'edit'
      }, {
        icon: 'switch',
        label: 'Status',
        openModal: 'status'
      }]}
    />
  )
}]

export {Columns}
